<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Taxation
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <el-alert
            v-if="!form.countryForTaxRepId"
            show-icon
            title="First, fill out the page Business & Accounting"
            type="warning"
            :closable="false">
          </el-alert>

          <el-form :disabled="!form.countryForTaxRepId" :model="form" :rules="rules" label-position="top" size="mini" status-icon ref="form">
            <el-row :gutter="20">
              <el-col :span="8" :offset="0">
                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <!-- <el-form-item label="Country for Tax reporting" prop="countryForTaxRepId">
                      <el-select v-model="form.countryForTaxRepId" filterable style="width: 100%;" @change="changeCountry">
                        <el-option v-for="item in countries"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item> -->
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8" :offset="0">
                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Tax reporting Country Home Currency" prop="taxReporting">
                      <el-input disabled label="" v-model="form.taxReporting"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <h4 class="block-title">Bureau of Internal Revenue (BIR)</h4>
            <el-row :gutter="20">
              <el-col :span="8" :offset="0">

                <el-row :gutter="20">
                  <el-col :span="12" :offset="0">
                    <el-form-item label="Tax Payer Classification" prop="taxClassificationId">
                      <el-select v-model="form.taxClassificationId" filterable style="width: 100%;">
                        <el-option v-for="item in taxClassificationsList"
                                   :key="item.id"
                                   :label="item.code"
                                   :value="item.id"
                                   @click.native="() => { form.taxClassificationsName = item.name, form.taxClassificationsDescription = item.description }">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" :offset="0">
                    <el-form-item label="Name" prop="taxClassificationsName">
                      <el-input label="" v-model="form.taxClassificationsName" :disabled="true" placeholder="Name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24" :offset="0">
                    <el-form-item prop="taxClassificationsDescription">
                      <el-input label="" v-model="form.taxClassificationsDescription" :disabled="true" placeholder="Description"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <h4>Sales Tax Status</h4>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Registered As" prop="vatableRegisteredId">
                      <el-select v-model="form.vatableRegisteredId" filterable style="width: 100%;">
                        <el-option v-for="item in vatableRegisteredList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                          <span style="float: left">{{ item.name }}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.dbCode.off[0] }}</span>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Tax Formation" prop="taxFormation">
                      <el-select v-model="form.taxFormation" :disabled="!form.countryForTaxRepId" filterable style="width: 100%;" @change="taxFormationChange">
                        <el-option v-for="item in taxFormationList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Tax Formation List" prop="taxFormationListId">
                      <el-select v-model="form.taxFormationListId" :disabled="!form.taxFormation || !form.countryForTaxRepId" filterable style="width: 100%;">
                        <el-option v-for="item in taxFormationListList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Tax Identification No. (TIN)" prop="taxIdentification">
                      <el-input label="" v-model="form.taxIdentification" v-mask="'###-###-###-#####'"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="18" :offset="0">
                    <el-form-item label="Regional District Office (RDO)" prop="regionalDistrictOffice">
                      <el-select v-model="form.regionalDistrictOffice" :disabled="!form.countryForTaxRepId" filterable style="width: 100%;">
                        <el-option v-for="item in regionalDistrictOfficeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id"
                                   @click.native="() => form.regionalDistrictOfficeCode = item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" :offset="0">
                    <el-form-item label="RDO No." prop="regionalDistrictOfficeCode">
                      <el-input label="" v-model="form.regionalDistrictOfficeCode" :disabled="true" placeholder="Code"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <h4>Income Tax</h4>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Method of Deduction" prop="methodOfDeduction">
                      <el-select v-model="form.methodOfDeduction" :disabled="!form.countryForTaxRepId" filterable style="width: 100%;">
                        <el-option v-for="item in methodOfDeductionList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Are you availing of tax relief under Special laws or International Tax Treaty?" prop="availingOfTaxRelief">
                      <el-radio-group v-model="form.availingOfTaxRelief">
                        <el-radio label="yes">Yes</el-radio>
                        <el-radio label="no">No</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="form.availingOfTaxRelief === 'yes'" label="Specify">
                      <el-select v-model="form.specify" filterable style="width: 100%;">
                        <el-option v-for="item in specifyList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <div>
                  <div v-if="form.certificate">
                    <div class="file-row">
                      <span class="file-row__file-name">{{ form.certificate.name }}</span>
                      <el-button
                          style="margin-left: 20px;"
                          size="mini"
                          type="danger"
                          plain
                          icon="el-icon-delete"
                          @click="deleteFile(71)"></el-button>
                    </div>
                  </div>
                  <el-button v-else style="width:100%" @click="() => $refs.fileInput.click()">
                    Upload the COR (Certificate of Registration)
                  </el-button>
                  <input ref='fileInput' v-show="false" @change="handleUploadFile" type="file">
                </div>

              </el-col>
              <el-col :span="8" :offset="0">
                <h4>Withholding Tax Agent</h4>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Category of Withholding Agent" prop="categoryOfWithholdingAgent">
                      <el-select v-model="form.categoryOfWithholdingAgent" filterable style="width: 100%;">
                        <el-option v-for="item in categoryOfWithholdingAgentList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Registered Name" prop="registeredName">
                      <el-input label="" v-model="form.registeredName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Taxpayer Name" prop="taxPayerName">
                      <el-input label="" v-model="form.taxPayerName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Registered/Business Address" prop="businessAddress">
                      <el-input label="" v-model="form.businessAddress"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <h4>Authorised Representative/Signatory</h4>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Name" prop="signatoryName">
                      <el-input label="" v-model="form.signatoryName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Position/Title" prop="signatoryPosition">
                      <el-input label="" v-model="form.signatoryPosition"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

              </el-col>
            </el-row>
            <el-form-item style="margin-top: 20px;">
              <el-button :disabled="!form.countryForTaxRepId" @click="save('form')" class="modal__btn" type="primary" plain size="big">{{$t('settings_companyAdditionalInfo_save')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "informationTaxation",
  data(){
    return {
      form: {
        countryForTaxRepId: null,
        taxReporting: null,
        taxClassificationId: null,
        taxClassificationsName: null,
        taxClassificationsDescription: null,
        vatableRegisteredId: null,
        taxFormation: null,
        taxFormationListId: null,
        taxIdentification: null,
        regionalDistrictOffice: null,
        regionalDistrictOfficeCode: null,
        methodOfDeduction: null,
        availingOfTaxRelief: 'no',
        categoryOfWithholdingAgent: null,
        registeredName: null,
        businessAddress: null,
        signatoryName: null,
        signatoryPosition: null,
        certificate: null,
        specify: null,
        taxPayerName: null
      },
      rules: {
        taxFormation: [{ required: true, message: 'Please select Tax Formation', trigger: 'change' }],
        taxIdentification: [{ required: true, message: 'Please input Tax Identification No. (TIN)', trigger: 'change' }],
        taxClassificationId: [{ required: true, message: 'Tax Payer Classification', trigger: 'change' }],
        regionalDistrictOffice: [{ required: true, message: 'Regional District Office (RDO)', trigger: 'change' }],
        vatableRegisteredId: [{ required: true, message: 'Registered As', trigger: 'change' }],
        // taxFormationListId: [{ required: true, message: 'Please select Point Tax Formation', trigger: 'change' }],
      },
      countries: [],
      vatableRegisteredList: [
        // { id: 'Vatable', name: 'Vatable' },
        // { id: 'Percentage Tax', name: 'Percentage Tax' },
        // { id: 'Tax Exempt', name: 'Tax Exempt' },
        // { id: 'Zero Rated', name: 'Zero Rated' },
      ],
      taxFormationList: [],
      taxFormationListList: [],
      regionalDistrictOfficeList: [],
      methodOfDeductionList: [],
      taxClassificationsList: [],
      categoryOfWithholdingAgentList: [
        { id: 'Private (P)', name: 'Private (P)' },
        { id: 'Government (G)', name: 'Government (G)' },
      ],
      specifyList: [],
      countryId: 0
    }
  },
  async mounted(){
    await this.loadCountryId()
    await this.loadCountry()
    await this.loadData()
    await this.loadItem()
    await this.loadFile()
  },
  methods: {
    async loadCountryId() {
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data: item } = await axios.get(`/api/v1/company-taxation-info/item?companyId=${this.$route.query.companyId}`)
        this.form.countryForTaxRepId = item.businessAndAccountingCountry ? item.businessAndAccountingCountry.id : null
      } catch (error) {
        console.log(error)
      }
    },
    async loadData() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const { data } = await axios.get(
          `/api/v1/company-taxation-info/directories?taxFormationCountryId=${
            this.form.countryForTaxRepId ? this.form.countryForTaxRepId : this.countryId
          }&rdoCountryId=${this.countryId}&methodOfDeductionCountryId=${this.countryId}`
      )
      this.taxFormationList = data.taxFormationList
      this.methodOfDeductionList = data.methodOfDeductionList
      this.regionalDistrictOfficeList = data.rdoList
      this.vatableRegisteredList = data.vatableRegisteredList
      this.taxClassificationsList = data.taxClassifications

      console.log('data', data)
      // const { data: taxFormationList } = await axios.get(`/api/v1/tax-formation/list?countryId=${this.form.countryForTaxRepId ? this.form.countryForTaxRepId : this.countryId}`)
      // this.taxFormationList = taxFormationList.list
      // const { data: regionalDistrictOfficeList } = await axios.get(`/api/v1/rdo/list?countryId=${this.countryId}`)
      // this.regionalDistrictOfficeList = regionalDistrictOfficeList.list
      // const { data: methodOfDeductionList } = await axios.get(`/api/v1/method-of-deduction/list?countryId=${this.countryId}`)
      // this.methodOfDeductionList = methodOfDeductionList.list
      loader.hide()
    },
    async loadCountry() {
      const loader = this.$loading.show()
      const { data } = await axios.get(`/api/v1/country/directories?type=country&id=null`)
      this.countries = data.list
      loader.hide()
    },
    async loadItem() {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const { data: item } = await axios.get(`/api/v1/company-taxation-info/item?companyId=${this.$route.query.companyId}`)
      this.form.countryForTaxRepId = item.businessAndAccountingCountry ? item.businessAndAccountingCountry.id : null
      if (item.item) {
        this.form.taxReporting = item.item.taxReporting
        if (item.item.taxClassificationId) {
          // this.form.countryForTaxRepId = item.item.countryForTaxRepId
          this.form.taxFormation = item.item.taxFormationId
          this.form.taxFormationListId = item.item.taxFormationListId
          this.form.regionalDistrictOffice = item.item.rdoId
          const foundElement = this.regionalDistrictOfficeList.find(element => element.id === this.form.regionalDistrictOffice)
          this.form.regionalDistrictOfficeCode = foundElement.code
          this.form.methodOfDeduction = item.item.methodOfDeductionId
          this.form.vatableRegisteredId = item.item.vatableRegistered ? item.item.vatableRegistered.id : null
          this.form.taxClassificationId = item.item.taxClassificationId
          const foundElementTC = this.taxClassificationsList.find(element => element.id === this.form.taxClassificationId)
          this.form.taxClassificationsName = foundElementTC.name
          this.form.taxClassificationsDescription = foundElementTC.description
          this.form.taxIdentification = item.item.taxIdentification
          this.form.availingOfTaxRelief = item.item.availingOfTaxRelief
          this.form.categoryOfWithholdingAgent = item.item.categoryOfWithholdingAgent
          this.form.registeredName = item.item.registeredName
          this.form.businessAddress = item.item.businessAddress
          this.form.signatoryName = item.item.signatoryName
          this.form.signatoryPosition = item.item.signatoryPosition
          this.form.specify = item.item.specify
          this.form.taxPayerName = item.item.taxPayerName
          await this.loadTaxFormationList(this.form.taxFormation)
        }
      }
    },
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
    async loadFile() {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const { data } = await axios.post(`/api/v1/entityFiles/listOfArrTypeId?entityId=${this.$route.query.companyId}`, { entityTypeIdArr: [71] })
      this.form.certificate = data.list.length ? data.list[0] : null
    },
    async handleUploadFile(e) {
      await this.uploadFile(e.target.files[0], 71)
      this.$refs.fileInput.value = null
      await this.loadFile()
    },
    async uploadFile(file, entityTypeId) {
      const loader = this.$loading.show()
      const formData = new FormData()
      formData.append('file', file)
      formData.append('convert', 'false')
      formData.append('entityId', this.$route.query.companyId)
      formData.append('historyEntityId', '0')
      formData.append('taskId', 'null')
      formData.append('entityTypeId', entityTypeId)
      formData.append('oldParentId', null)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      await axios.post(`/api/v1/entityFiles/create?companyId=${this.$route.query.companyId}`, formData)
      loader.hide()
    },
    async deleteFile(entityTypeId) {
      const loader = this.$loading.show()
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      await axios.get(`/api/v1/entityFiles/delete?companyId=${this.$route.query.companyId}&fileId=${this.form.certificate.id}&entityId=${this.$route.query.companyId}&historyEntityId=0&taskId=null&entityTypeId=${entityTypeId}&deleteChild=false`)
      this.form.certificate = null
      loader.hide()
      await this.loadFile()
    },
    async changeCountry(countryId) {
      console.log('countryId', countryId)
      this.taxFormationList = []
      this.form.taxFormation = null
      this.taxFormationListList = []
      this.form.taxFormationListId = null
      this.regionalDistrictOfficeList = []
      this.form.regionalDistrictOffice = null
      this.form.regionalDistrictOfficeCode = null
      this.methodOfDeductionList = []
      this.form.methodOfDeduction = null
      await this.loadData()
    },
    async taxFormationChange(taxFormationId) {
      this.form.taxFormationListId = null
      this.taxFormationListList = []
      await this.loadTaxFormationList(taxFormationId)

    },
    async loadTaxFormationList(taxFormationId) {
      const loader = this.$loading.show()
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const { data } = await axios.get(`/api/v1/tax-formation-list/list?countryId=${this.form.countryForTaxRepId}&taxFormationId=${taxFormationId}`)
      this.taxFormationListList = data.list
      loader.hide()
    },
    save(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          const payload = {
            countryForTaxRepId: this.form.countryForTaxRepId,
            taxFormationId: this.form.taxFormation,
            taxFormationListId: this.form.taxFormationListId,
            rdoId: this.form.regionalDistrictOffice,
            methodOfDeductionId: this.form.methodOfDeduction,
            vatableRegisteredId: this.form.vatableRegisteredId,
            taxClassificationId: this.form.taxClassificationId,
            taxReporting: this.form.taxReporting,
            taxIdentification: this.form.taxIdentification,
            availingOfTaxRelief: this.form.availingOfTaxRelief,
            categoryOfWithholdingAgent: this.form.categoryOfWithholdingAgent,
            registeredName: this.form.registeredName,
            businessAddress: this.form.businessAddress,
            signatoryName: this.form.signatoryName,
            signatoryPosition: this.form.signatoryPosition,
            specify: this.form.specify,
            taxPayerName: this.form.taxPayerName
          }
          let loader = this.$loading.show();
          try {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            await axios.post(`/api/v1/company-taxation-info/save?companyId=${this.$route.query.companyId}`, payload)
            this.$message({
              type: 'success',
              message: 'Save'
            });
          } catch (error) {
            console.log(error)
          } finally {
            loader.hide()
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper {
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
      .block-title {
        text-decoration: underline;
      }
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}

/deep/.el-form-item__label {
  color: #000;
  font-weight: bold;
  padding: 0;
}

.used {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
</style>
